import { render, staticRenderFns } from "./AutorizationPage.vue?vue&type=template&id=0d3da87f&scoped=true"
import script from "./AutorizationPage.vue?vue&type=script&lang=js"
export * from "./AutorizationPage.vue?vue&type=script&lang=js"
import style0 from "./AutorizationPage.vue?vue&type=style&index=0&id=0d3da87f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d3da87f",
  null
  
)

export default component.exports